// Routes where the floating "Ask Clara" launcher is not rendered.
//   /expo        single-conversion campaign page: Clara would overlap the hero
//                and compete with the one booking CTA.
//   /play-piano  on iPhone SE / iPhone 15 the bubble covers piano keys on the
//                first screen (Mark, 2026-10-31). Exact route only, so
//                /instruments/piano and the home page keep Clara.
export function shouldHideClara(pathname = '') {
  if (pathname.startsWith('/expo')) return true;
  return /^\/play-piano\/?$/.test(pathname);
}
